import { render, staticRenderFns } from "./Reference.vue?vue&type=template&id=451f6602&scoped=true"
var script = {}
import style0 from "./Reference.vue?vue&type=style&index=0&id=451f6602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451f6602",
  null
  
)

export default component.exports